// extracted by mini-css-extract-plugin
module.exports = {"chip":"chip-button_chip__APBdZ","black":"chip-button_black__GqS_M","transparent":"chip-button_transparent__U30vb"};